import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-recommendation-report.controller';
import directive from './attach-recommendation-report.directive';


export default angular.module('app.components.advisory.auditTrail.attachRecommendationReport', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachRecommendationReport', directive)
  .controller('AttachRecommendationReportController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachRecommendationReport created');
